import usePrevious from '@react-hook/previous';
import React from 'react';

/**
 * Executes callback when value changes from a non-undefined value.
 */
export const useOnValueChanged = <T,>(value: T, onChange: (prevValue: T, newValue: T) => void) => {
  const prevValue = usePrevious(value);

  React.useEffect(() => {
    if (prevValue !== undefined && prevValue !== value) {
      onChange(prevValue, value);
    }
  }, [onChange, prevValue, value]);
};
